var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgOpenTrack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M7.038.95L.969 5.502v7.587h12.138V5.502L7.038.95zm0 7.327l4.728 4.053H2.311l4.727-4.053zm5.311 3.554L9.021 8.978l3.328-2.614v5.467zm-.314-6.185L8.434 8.475 7.038 7.279 5.642 8.475l-3.6-2.829 4.996-3.747 4.997 3.747zm-6.98 3.332l-3.327 2.853V6.364l3.327 2.614z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenTrack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/openTrack.d79a7bd9.svg";
export { ForwardRef as ReactComponent };